import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromSiteAnnouncements from './+state/site-announcements.reducer'
import { SiteAnnouncementsEffects } from './+state/site-announcements.effects'
import { SiteAnnouncementsFacade } from './+state/site-announcements.facade'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromSiteAnnouncements.SITE_ANNOUNCEMENTS_FEATURE_KEY,
      fromSiteAnnouncements.siteAnnouncementsReducer,
    ),
    EffectsModule.forFeature([SiteAnnouncementsEffects]),
  ],
  providers: [SiteAnnouncementsFacade],
})
export class GbDashboardStaffDataAccessSiteAnnouncementsModule {}
